<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>添加人员</p>
                <img @click="close" src="../../assets/img/common/editPicClose.svg" alt="">
            </div>
            <div class="select-container">
                <div class="left-container">
                    <div class="select-container">
                        <p @click="type = 'zm'" :class="{on: type == 'zm'}">按字母排序</p>
                        <p @click="type = 'depart'" :class="{on: type == 'depart'}">按部门排序</p>
                        <p v-if="o.platform_key == 'new_media_knews'" @click="type = 'kankan'" :class="{on: type == 'kankan'}">看看号排序</p>
                    </div>
                    <div v-if="type == 'zm'" class="input-container">
                        <input v-model="key_word" @keydown.enter="search" placeholder="请输入要查找的人员" type="text">
                        <i @click="search" class="search"></i>
                    </div>
                    <div v-click-outside="closeShowSelect" v-if="type == 'depart'" class="selectInput-container">
                        <p>
                            <span @click="changeShowSelect" v-show="!showSelect">{{departName}}</span>
                            <input @input="searchInput" ref="searchDom" v-show="showSelect" :placeholder="departName" v-model="searchDepart" type="text">
                        </p>
                        <i @click="changeShowSelect" class="arrow"></i>
                        <ul v-if="showSelect">
                            <li @click="selected(item);showSelect = false;searchDepart = ''" v-for="item in saveDepartsList" :key="item.name" :class="{on: item.selected}">
                                <span>{{ item.name }}</span>
                                <i></i>
                            </li>
                        </ul>
                    </div>
                    <div v-click-outside="closeShowKanKanSelect" v-if="type == 'kankan'" class="selectInput-container">
                        <p>
                            <span @click="changeShowKanKanSelect" v-show="!showKanKanSelect">{{kankanName}}</span>
                            <input @input="searchKanKanInput" ref="searchKanKanDom" v-show="showKanKanSelect" :placeholder="kankanName" v-model="searchKanKan" type="text">
                        </p>
                        <i @click="changeShowKanKanSelect" class="arrow"></i>
                        <ul v-if="showKanKanSelect">
                            <li @click="selectedKanKan(item);showKanKanSelect = false;searchKanKan = ''" v-for="item in saveKanKanList" :key="item.name" :class="{on: item.selected}">
                                <span>{{ item.name }}</span>
                                <i></i>
                            </li>
                        </ul>
                    </div>
                    <div v-if="type == 'kankan'" class="sh-container">
                        <p v-for="(item, index) in kankan" :key="index" @click="roleIndex = index" :class="{on: roleIndex == index}">{{index == 0 ? '编辑' : index == 1 ? '一审' : index == 2 ? '二审' : '三审' }}</p>
                    </div>
                    <ul v-if="type == 'zm'">
                        <li v-for="(item,index) in users" :key="index">
                            <p>{{item.name}}</p>
                            <ul>
                                <li v-for="(val,key) in item.list" :key="key">
                                    <i @click="change(val)" :class="{on: val.is_selected}"></i>
                                    <p>{{val.truename}}-{{val.username}}</p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <ul v-if="type == 'depart'">
                        <li v-if="item.list.length > 0" class="departList" v-for="(item,index) in departs" :key="index">
                            <div v-for="(val,key) in item.list" :key="key">
                                <i @click="change(val)" :class="{on: val.is_selected}"></i>
                                <p>{{val.truename}}-{{val.username}}</p>
                            </div>
                        </li>
                    </ul>
                    <ul v-if="type == 'kankan'">
                        <li v-for="(item,index) in kankan[roleIndex].list" :key="index">
                            <p>{{item.name}}</p>
                            <ul>
                                <li v-for="(val,key) in item.list" :key="key">
                                    <i @click="change(val)" :class="{on: val.is_selected}"></i>
                                    <p>{{val.truename}}-{{val.username}}</p>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="right-container">
                    <div class="title">已选<span>{{list.length}}</span>人</div>
                    <ul>
                        <li v-for="(item,index) in list" :key="index">
                            <p>{{item.truename}}-{{item.username}}</p>
                            <i @click="del(item.uid)"></i>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btns-container">
                <div @click="selectedAll" class="selected">
                    <i :class="{on: ((totalLength == selectTotal) || (selectTotal > totalLength)) && selectTotal > 0}"></i>
                    <span>全选</span>
                </div>
                <p @click="confirm" class="btn on">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import vClickOutside from "v-click-outside";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        data() {
            return {
                show: false,
                o: {},
                c: null,
                key_word: '',
                users: [],
                list: [],
                departs: [],
                kankan: [],
                columns: [],
                saveKanKan: [],
                saveDeparts: [],
                departsList: [],
                saveDepartsList: [],
                kankanList: [],
                saveKanKanList: [],
                departName: '全部',
                kankanName: '',
                type: 'zm',
                showKanKanSelect: false,
                showSelect: false,
                isSelectAll: false,
                totalLength: 0,
                selectTotal: 0,
                searchDepart: '',
                searchKanKan: '',
                roleIndex: 0
            }
        },
        watch: {
            type() {
                if(this.type == 'zm'){
                    let totalLength = 0
                    this.users.forEach(el => {
                        el.list.forEach(els => {
                            totalLength++
                        })
                    })
                    this.totalLength = totalLength
                }else if(this.type == 'kankan'){
                    let totalLength = 0
                    this.kankan[this.roleIndex].list.forEach(el => {
                        el.list.forEach(els => {
                            totalLength++
                        })
                    })
                    this.totalLength = totalLength
                }else{
                    let totalLength = 0
                    if(this.departName == '全部'){
                        this.departs.forEach(el => {
                            el.list.forEach(els => {
                                totalLength++
                            })
                        })
                        this.totalLength = totalLength
                    }else{
                        this.departs.forEach(el => {
                            if(el.name == this.departName){
                                el.list.forEach(els => {
                                    totalLength++
                                })       
                            }
                        })
                        
                        this.totalLength = totalLength
                    }
                }
                this.departs.forEach(el1 => {
                    el1.list.forEach(val1 => {
                        val1.is_selected = false
                    })
                })
                this.saveDeparts.forEach(el2 => {
                    el2.list.forEach(val2 => {
                        val2.is_selected = false
                    })
                })
                this.users.forEach(el3 => {
                    el3.list.forEach(val3 => {
                        val3.is_selected = false
                    })
                })
                this.list.forEach(el => {
                    this.departs.forEach(el1 => {
                        el1.list.forEach(val1 => {
                            if(el.uid == val1.uid){
                                // console.log(val1)
                                val1.is_selected = true
                            }
                        })
                    })
                    this.saveDeparts.forEach(el2 => {
                        el2.list.forEach(val2 => {
                            if(el.uid == val2.uid){
                                // console.log(val2)
                                val2.is_selected = true
                            }
                        })
                    })
                    this.users.forEach(el3 => {
                        el3.list.forEach(val3 => {
                            if(el.uid == val3.uid){
                                // console.log(val3)
                                val3.is_selected = true
                            }
                        })
                    })
                })
            },
            users: {
                deep: true,
                handler: function (n) {
                    // if(this.key_word == ''){
                        let list = this.list
                        this.users.forEach(el => {
                            el.list.forEach(val => {
                                if(val.is_selected){
                                    list.push(val)
                                }
                            })
                        });
                        list = common.uniqObjInArray1(list)
                        this.list = list
                    // }
                }
            },
            departs: {
                deep: true,
                handler: function (n) {
                    // if(this.key_word == ''){
                        let totalLength = 0
                        let list = this.list
                        this.departs.forEach(el => {
                            el.list.forEach(val => {
                                if(val.is_selected){
                                    list.push(val)
                                }
                            })
                        });
                        list = common.uniqObjInArray1(list)
                        this.list = list
                    // }
                }
            },
            roleIndex() {
                let totalLength = 0
                let selectTotal = 0
                this.kankan[this.roleIndex].list.forEach(el => {
                    el.list.forEach(els => {
                        totalLength++
                        if(els.is_selected){
                            selectTotal++
                        }
                    })
                })
                this.selectTotal = selectTotal
                this.totalLength = totalLength
            }
        },
        methods: {
            searchInput() {
                if(this.searchTime){
                    clearTimeout(this.searchTime)
                    this.searchTime = null
                }

                this.searchTime = setTimeout(() => {
                    console.log(this.searchDepart)
                    let list = JSON.parse(JSON.stringify(this.departsList))
                    if(!this.searchDepart){
                        this.saveDepartsList = list
                    }else{
                        this.saveDepartsList = list.filter(el => {
                            return el.name.indexOf(this.searchDepart) > -1
                        })
                    }
                },300)
            },
            searchKanKanInput() {
                if(this.searchTime){
                    clearTimeout(this.searchTime)
                    this.searchTime = null
                }

                this.searchTime = setTimeout(() => {
                    let list = JSON.parse(JSON.stringify(this.kankanList))
                    if(!this.searchKanKan){
                        this.saveKanKanList = list
                    }else{
                        this.saveKanKanList = list.filter(el => {
                            return el.name.indexOf(this.searchKanKan) > -1
                        })
                    }
                },300)
            },
            selectedAll() {
                if(this.type == 'zm'){
                    this.list = []
                    let selectTotal = 0
                    if(this.totalLength == this.selectTotal && this.selectTotal > 0){
                        let users = this.users;
                        users.forEach(el => {
                            el.list.forEach(els => {
                                els.is_selected = false;
                            })
                        })
                        this.selectTotal = 0
                        this.users = users
                    }else{
                        let users = this.users;
                        users.forEach(el => {
                            el.list.forEach(els => {
                                els.is_selected = true;
                                selectTotal++
                            })
                        })
                        this.selectTotal = selectTotal
                        // this.users = users
                    }
                }else if(this.type == 'kankan'){
                    let selectTotal = 0
                    if(this.totalLength == this.selectTotal && this.selectTotal > 0){
                        let kankan = this.kankan[this.roleIndex].list;
                        kankan.forEach(el => {
                            el.list.forEach(els => {
                                els.is_selected = false;
                            })
                        })
                        this.selectTotal = 0
                        this.kankan[this.roleIndex].list = kankan
                    }else{
                        let kankan = this.kankan[this.roleIndex].list;
                        kankan.forEach(el => {
                            el.list.forEach(els => {
                                els.is_selected = true;
                                selectTotal++
                            })
                        })
                        this.selectTotal = selectTotal
                        this.kankan[this.roleIndex].list = kankan
                    }
                }else{
                    let selectTotal = 0
                    let departs = this.departs
                    if(this.totalLength == this.selectTotal && this.selectTotal > 0){
                        if(this.departName == '全部'){
                            departs.forEach(el => {
                                el.list.forEach(els => {
                                    els.is_selected = false;
                                })
                            })
                            this.list = []
                            this.selectTotal = 0
                            this.departs = departs
                        }else{
                            let list = this.list
                            departs.forEach(el => {
                                if(el.name == this.departName){
                                    el.list.forEach(els => {
                                        els.is_selected = false;
                                        list = list.filter(elss => {
                                            return elss.uid != els.uid
                                        })
                                    })
                                }
                            })
                            this.list = list
                            this.selectTotal = 0
                            this.departs = departs
                        }
                    }else{
                        if(this.departName == '全部'){
                            departs.forEach(el => {
                                el.list.forEach(els => {
                                    els.is_selected = true;
                                    selectTotal++
                                })
                            })
                            this.list = []
                            this.selectTotal = selectTotal
                            this.departs = departs
                        }else{
                            let list = this.list
                            departs.forEach(el => {
                                if(el.name == this.departName){
                                    el.list.forEach(els => {
                                        els.is_selected = true;
                                        selectTotal++
                                        list.push(els)
                                    })
                                }
                            })
                            this.list = list
                            this.selectTotal = selectTotal
                            this.departs = departs
                        }
                    }
                }
            },
            selected(item) {
                let totalLength = 0
                let selectTotal = 0
                this.departsList.forEach(el => {
                    if(el.name == item.name){
                        el.selected = true;
                    }else{
                        el.selected = false;
                    }
                })

                // item.selected = true;

                this.saveDepartsList = JSON.parse(JSON.stringify(this.departsList))
                this.departName = item.name
                if(item.name == '全部'){
                    this.departs = this.saveDeparts
                    this.departs.forEach(el => {
                        el.list.forEach(els => {
                            totalLength++
                            if(els.is_selected){
                                selectTotal++
                            }
                        })
                    })
                    this.totalLength = totalLength
                    this.selectTotal = selectTotal
                }else{
                    let arr = []
                    this.saveDeparts.forEach(el => {
                        if(el.name.toString().indexOf(item.name) > -1){
                            arr.push(el)
                        }
                    })
                    this.departs = arr
                    this.departs.forEach(el => {
                        if(el.name == item.name){
                            el.list.forEach(els => {
                                totalLength++
                                if(els.is_selected){
                                    selectTotal++
                                }
                            })
                        }
                    })
                    this.totalLength = totalLength
                    this.selectTotal = selectTotal
                }
            },
            selectedKanKan(item) {
                let totalLength = 0
                let selectTotal = 0
                this.kankanList.forEach(el => {
                    if(el.name == item.name){
                        el.selected = true;
                    }else{
                        el.selected = false;
                    }
                })

                this.saveKanKanList = JSON.parse(JSON.stringify(this.kankanList))
                this.kankanName = item.name
                this.roleIndex = 0

                let nowColumns = []

                this.columns.forEach(el => {
                    if(el.name == item.name){
                        nowColumns = el.verified_user_list
                    }
                })

                let column = this.getColumnList(nowColumns,this.users)
                        
                this.kankan = column
            },
            closeShowSelect() {
                this.showSelect = false
                this.searchDepart = ''
            },
            closeShowKanKanSelect() {
                this.showKanKanSelect = false
                this.searchKanKan = ''
            },
            changeShowSelect() {
                this.showSelect = !this.showSelect;

                this.$nextTick(() => {
                    if(this.showSelect){
                        this.$refs.searchDom.focus()
                    }else{
                        this.searchDepart = ''
                    }
                })
                
            },
            changeShowKanKanSelect() {
                this.showKanKanSelect = !this.showKanKanSelect;

                this.$nextTick(() => {
                    if(this.showKanKanSelect){
                        this.$refs.searchKanKanDom.focus()
                    }else{
                        this.searchKanKan = ''
                    }
                })
                
            },
            confirm() {
                // this.c(1)
                console.log(this.list)
                let uid = []
                this.list.forEach(el => {
                    uid.push(el.uid)
                })
                uid = uid.join(',')
                const info = {
                    role_type: this.o.role_type,
                    platform_key: this.o.platform_key,
                    column_key: this.o.column_key,
                    uids: uid
                };

                common.myFetch(apis.newMediaPlatformSetUsers, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.c(true)
                        this.close()
                    }
                });
                
            },
            change(val) {
                if(val.is_selected){
                    this.list = this.list.filter(el => {
                        return el.uid != val.uid
                    })
                }
                val.is_selected = !val.is_selected   
                let selectTotal = 0
                if(this.type == 'zm'){
                    this.users.forEach(el => {
                        el.list.forEach(els => {
                            if(els.is_selected){
                                selectTotal++
                            }
                        })
                    })
                    this.selectTotal = selectTotal
                }else if(this.type == 'kankan'){
                    this.kankan[this.roleIndex].list.forEach(el => {
                        el.list.forEach(els => {
                            if(els.is_selected){
                                selectTotal++
                            }
                        })
                    })
                    this.selectTotal = selectTotal
                    console.log(selectTotal)
                }else{
                    if(this.departName == '全部'){
                        this.departs.forEach(el => {
                            el.list.forEach(els => {
                                if(els.is_selected){
                                    selectTotal++
                                }
                            })
                        })
                        this.selectTotal = selectTotal
                    }else{
                        this.departs.forEach(el => {
                            if(el.name == this.departName){
                                el.list.forEach(els => {
                                    if(els.is_selected){
                                        selectTotal++
                                    }
                                })
                            }
                        })
                        this.selectTotal = selectTotal
                    }
                }
            },
            del(uid) {
                let selectTotal = 0
                if(this.type == 'zm'){
                    this.list = this.list.filter(el => {
                        return el.uid != uid
                    })
                    this.users.forEach(el => {
                        el.list.forEach(val => {
                            if(val.uid == uid){
                                val.is_selected = false
                            }
                        })
                    })
                    this.users.forEach(el => {
                        el.list.forEach(els => {
                            if(els.is_selected){
                                selectTotal++
                            }
                        })
                    })
                    this.selectTotal = selectTotal
                }else if(this.type == 'kankan'){
                    this.list = this.list.filter(el => {
                        return el.uid != uid
                    })

                    this.kankan.forEach(el => {
                        if(el.list.length > 0){
                            el.list.forEach(val => {
                                console.log(val)
                                val.list.forEach(els => {
                                    if(els.uid == uid){
                                        els.is_selected = false
                                    }
                                })
                            })
                        }
                    })

                    this.kankan[this.roleIndex].list.forEach(el => {
                        el.list.forEach(els => {
                            if(els.is_selected){
                                selectTotal++
                            }
                        })
                    })

                    this.selectTotal = selectTotal
                }else{
                    this.list = this.list.filter(el => {
                        return el.uid != uid
                    })
                    this.saveDeparts.forEach(el => {
                        el.list.forEach(val => {
                            if(val.uid == uid){
                                val.is_selected = false
                            }
                        })
                    })
                    this.departs.forEach(el => {
                        el.list.forEach(val => {
                            if(val.uid == uid){
                                val.is_selected = false
                            }
                        })
                    })
                    if(this.departName == '全部'){
                        this.departs.forEach(el => {
                            el.list.forEach(els => {
                                if(els.is_selected){
                                    selectTotal++
                                }
                            })
                        })
                        this.selectTotal = selectTotal
                    }else{
                        this.departs.forEach(el => {
                            if(el.name == this.departName){
                                el.list.forEach(els => {
                                    if(els.is_selected){
                                        selectTotal++
                                    }
                                })
                            }
                        })
                        this.selectTotal = selectTotal
                    }
                }
            },
            search() {
                this.getUserList()
            },
            open(o,c) {
                console.log(o,c)
                this.o = o
                this.c = c
                this.getUserList()
                this.show = true
            },
            close() {
                this.c(false)
                this.show = false
            },
            getUserList() {
                const info = {
                    column_key: this.o.column_key,
                    platform_key: this.o.platform_key,
                    role_type: this.o.role_type,
                    key_word: this.key_word
                };

                common.myFetch(apis.newMediaPlatformUserList, info).then(r => {
                    if (r) {
                        console.log(r)
                        this.columns = r.columns
                        this.users = r.users
                        this.departs = JSON.parse(JSON.stringify(r.departs))
                        this.saveDeparts = JSON.parse(JSON.stringify(r.departs))
                        let departName = '全部'
                        let departsList = [{
                                name: '全部',
                                selected: true
                            }]
                        r.departs.forEach(el => {
                            departsList.push({
                                name: el.name,
                                selected: false
                            })
                        })
                        this.departName = departName
                        this.departsList = departsList

                        this.saveDepartsList = departsList
                        // if(this.key_word == ''){
                        let totalLength = 0
                        let selectTotal = 0
                        let list = this.list
                        r.users.forEach(el => {
                            el.list.forEach(val => {
                                if(val.is_selected){
                                    list.push(val)
                                    selectTotal++
                                }
                                totalLength ++
                            })
                        });
                        this.totalLength = totalLength
                        this.selectTotal = selectTotal
                        list = common.uniqObjInArray1(list)
                        this.list = list

                        if(list.length > 0){
                            this.list.forEach(el1 => {
                                this.users.forEach(el => {
                                    el.list.forEach(val => {
                                        if(val.uid == el1.uid){
                                            val.is_selected = true
                                        }
                                    })
                                })
                            })
                        }

                        let kankanList = [];
                        let nowColumns = []

                        r.columns.forEach((el,index) => {
                            kankanList.push({
                                name: el.name,
                                selected: index == 0 ? true : false
                            })

                            if(index == 0){
                                this.kankanName = el.name
                                nowColumns = el.verified_user_list
                            }
                        })

                        this.kankanList = kankanList
                        this.saveKanKanList = kankanList

                        let column = this.getColumnList(nowColumns,r.users)
                        
                        this.kankan = column
                        // }
                    }
                });
            },
            getColumnList(nowColumns,users) {
                nowColumns.forEach((el) => {
                    el.list = []
                    if(el.uid_list.length > 0){

                        el.uid_list.forEach(el1 => {
                            users.forEach(els => {
                                if(els.list.length > 0){
                                    let name = ''
                                    let list = []
                                    els.list.forEach(val => {
                                        if(val.uid == el1){
                                            name = els.name
                                            list.push(val)
                                        }
                                    })

                                    if(name){
                                        el.list.push({
                                            name: name,
                                            list: [...list]
                                        })
                                    }
                                }
                            })
                        })
                    }
                })

                return nowColumns
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    border-radius: 2px;
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1008;

    .box-container {
        display: flex;
        flex-direction: column;
        width: 834px;
        height: 552px;
        padding: 20px 0px 0px;
        background: #F9F9F9;
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 17px;
            padding: 0 30px;
            box-sizing: border-box;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        & > .select-container {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            flex: 1;
            min-height: 0;
            padding: 0 30px;
            box-sizing: border-box;
            .left-container {
                display: flex;
                flex-direction: column;
                width: 50%;
                height: 100%;
                overflow: hidden;

                .title {
                    width: 355px;
                    height: 42px;
                    line-height: 42px;
                    background: #D5DEDB;
                    font-size: 13px;
                    color: #666666;
                    font-weight: bold;
                    text-align: center;
                }

                .select-container {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 20px;
                    margin-left: 4px;

                    p {
                        font-size: 16px;
                        line-height: 22px;
                        color: #666666;
                        padding-bottom: 4px;
                        box-sizing: border-box;
                        font-weight: bold;
                        margin-right: 30px;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            color: #41B48C;
                            border-bottom: 3px solid #41B48C;
                            box-sizing: border-box;
                        }
                    }
                }

                .selectInput-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 16px 0 20px;
                    box-sizing: border-box;
                    width: 350px;
                    height: 40px;
                    background: rgba(185,195,195,0.2);
                    border-radius: 2px;
                    margin-bottom: 10px;
                    margin-left: 4px;
                    user-select: none;
                    cursor: pointer;

                    p {
                        display: flex;
                        align-items: center;
                        height: 100%;
                        flex: 1;
                        min-width: 0;
                        font-size: 14px;
                        line-height: 20px;
                        color: #323B4B;

                        span {
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: transparent;
                        }
                    }

                    i.arrow {
                        display: block;
                        width: 12px;
                        height: 8px;
                        background: url('./assets/arrow.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }   

                    ul {
                        position: absolute;
                        top: 52px;
                        left: 0;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        height: 210px;
                        overflow-y: auto;
                        border-radius: 4px;

                        &::-webkit-scrollbar {
                            width: 6px;
                        }
                        &::-webkit-scrollbar-thumb {
                            background: #ddd;
                            border-radius: 2px;
                        }

                        li {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            min-height: 42px;
                            padding: 0 16px 0 20px;
                            box-sizing: border-box;
                            background: #ECEEEF;
                            font-size: 14px;
                            color: #323B4B;

                            &:hover {
                                background: #41B48C;
                                color: #FFF;
                            }

                            &.on {
                                background: #41B48C;
                                color: #FFF;

                                i {
                                    display: block;
                                    width: 12px;
                                    height: 9px;
                                    background: url('./assets/pass.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                }

                .sh-container {
                    display: flex;
                    align-items: center;
                    width: 354px;
                    height: 36px;
                    padding: 3px;
                    box-sizing: border-box;
                    background: rgba(185,195,195,0.2);
                    border-radius: 18px;
                    margin-bottom: 20px;
                    margin-left: 4px;
                    overflow-x: auto;

                    p {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex: 1;
                        height: 100%;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #666666;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            background: #41B48C;
                            color: #FFF;
                        }
                    }
                }

                .input-container {
                    display: flex;
                    align-items: center;
                    width: 350px;
                    height: 40px;
                    background: rgba(185, 195, 195, 0.2);
                    border-radius: 20px;
                    margin-left: 4px;
                    margin-bottom: 10px;
                    padding: 0 20px;
                    box-sizing: border-box;

                    input {
                        width: 100%;
                        height: 100%;
                        background: transparent;

                        &::placeholder {
                            color: #B9C3C3;
                        }
                    }

                    .search {
                        display: block;
                        width: 16px;
                        height: 16px;
                        background: url('./assets/search.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }
                }

                & > ul {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-height: 0;
                    overflow-y: auto;
                    margin-left: 4px;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(185,195,195,0.5);
                        border-radius: 6px;
                    }

                    .departList {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        div {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            width: 350px;
                            height: 42px;
                            line-height: 42px;
                            font-size: 13px;
                            color: #323B4B;
                            padding: 0 10px;
                            box-sizing: border-box;

                            &:hover {
                                background: rgba(185, 195, 195, 0.15);
                            }

                            i {
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 8px;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                margin-right: 14px;

                                &.on {
                                    background-image: url('./assets/pass.png');
                                    background-color: #41B48C;
                                    background-repeat: no-repeat;
                                    background-position: center center;
                                    background-size: 12px 9px;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;
                                }
                            }
                        }
                    }

                    li {
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;
                        margin-bottom: 8px;

                        p {
                            font-size: 13px;
                            line-height: 18px;
                            box-sizing: border-box;
                            color: #666666;
                        }

                        ul {
                            margin-top: 10px;
                            display: flex;
                            flex-direction: column;

                            li {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                width: 350px;
                                height: 42px;
                                line-height: 42px;
                                font-size: 13px;
                                color: #323B4B;
                                padding: 0 10px;
                                box-sizing: border-box;

                                &:hover {
                                    background: rgba(185, 195, 195, 0.15);
                                }

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    border-radius: 8px;
                                    border: 1px solid #B9C3C3;
                                    box-sizing: border-box;
                                    margin-right: 14px;

                                    &.on {
                                        background-image: url('./assets/pass.png');
                                        background-color: #41B48C;
                                        background-repeat: no-repeat;
                                        background-position: center center;
                                        background-size: 12px 9px;
                                        border: 1px solid #41B48C;
                                        box-sizing: border-box;
                                    }
                                }
                            }
                        }
                        
                        // &:hover {
                        //     background: rgba(185, 195, 195, 0.15);
                        //     color: #41B48C;
                        
                        //     p {
                        //         color: #41B48C;
                        //     }
                        // }

                        // .on {
                        //     background: rgba(185, 195, 195, 0.15);
                        //     color: #41B48C;
                        // }
                    }
                }
            }

            .right-container {
                display: flex;
                flex-direction: column;
                width: 50%;
                height: 100%;
                border-radius: 4px;
                overflow: hidden;
                padding-left: 30px;
                box-sizing: border-box;

                .title {
                    font-size: 20px;
                    line-height: 28px;
                    color: #666666;
                    font-weight: bold;
                    margin-bottom: 16px;

                    span {
                        color: #41B48C;
                    }
                }

                ul {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    min-height: 0;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(185,195,195,0.5);
                        border-radius: 6px;
                    }

                    li {
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        height: 42px;
                        line-height: 42px;
                        padding: 0 10px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        // &:hover {
                        //     background: rgba(185, 195, 195, 0.15);

                        //     i {
                        //         display: block;
                        //     }
                        // }

                        i {
                            display: block;
                            width: 10px;
                            height: 10px;
                            background-image: url('./assets/del.png');
                            background-repeat: no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                        }

                        p {
                            font-size: 13px;
                            line-height: 18px;
                            color: #323B4B;
                            font-weight: 500;
                        }
                    }
                }
            }
        }

        .btns-container {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 70px;
            background: #F9F9F9;
            box-shadow: 0px 0px 10px 0px rgba(6,21,50,0.05);

            .selected {
                position: absolute;
                left: 30px;
                display: flex;
                align-items: center;
                user-select: none;
                cursor: pointer;

                i {
                    display: block;
                    width: 16px;
                    height: 16px;
                    border-radius: 8px;
                    border: 1px solid #B9C3C3;
                    box-sizing: border-box;
                    margin-right: 10px;

                    &.on {
                        background-image: url('./assets/pass.png');
                        background-color: #41B48C;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: 12px 9px;
                        border: 1px solid #41B48C;
                        box-sizing: border-box;
                    }
                }

                span {
                    font-size: 13px;
                    line-height: 18px;
                    color: #323B4B;
                }
            }

            .btn {
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                user-select: none;
                cursor: pointer;

                &.on {
                    background: #41B48C;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>